import type { Table } from "@tanstack/react-table";
import { X } from "lucide-react";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

import { DataTableExportExcel } from "./data-table-export-excel";
import { DataTableViewOptions } from "./data-table-view-options";

interface DataTableToolbarProps<TData> {
	table: Table<TData>;
	children?: React.ReactNode;
	className?: string;
	showViewOptions?: boolean;
	showReset?: boolean;
	showExportExcel?: boolean;
	exportFilename?: string;
}

function DataTableToolbar<TData>({
	table,
	children,
	className,
	showViewOptions = true,
	showReset = true,
	showExportExcel = false,
	exportFilename,
}: DataTableToolbarProps<TData>) {
	const isFiltered = table.getState().columnFilters.length > 0;

	return (
		<div className={cn("flex items-center justify-between", className)}>
			<div className="flex flex-1 items-center space-x-2 flex-wrap gap-y-2">
				{children}
				{showReset && isFiltered && (
					<Button
						variant="ghost"
						size="sm"
						onClick={() => table.resetColumnFilters()}
						className="h-8 px-2 lg:px-3"
					>
						Réinitialiser
						<X className="ml-1 size-3.5" />
					</Button>
				)}
			</div>
			<div className="flex items-center gap-2">
				{showExportExcel && (
					<DataTableExportExcel
						table={table}
						filename={exportFilename}
					/>
				)}
				{showViewOptions && <DataTableViewOptions table={table} />}
			</div>
		</div>
	);
}

export { DataTableToolbar };
